import React, { FC, useEffect } from "react";
import { FilterPanel } from "../FilterPanel/FilterPanel";
import { WorkOrderDNDItem } from "../WorkOrderDNDItem/WorkOrderDNDItem";
import { useAppDispatch } from "Redux/store";
import { getDashboardWorkOrder } from "Redux/Dashboard/reducer";
import { useWorkOrderDND } from "../useWorkOrderDND";
const WorkOrderDNDList: FC = () => {
  const { workOrderParams } = useWorkOrderDND();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getDashboardWorkOrder(workOrderParams));
  }, [dispatch, workOrderParams]);
  return (
    <>
      <FilterPanel />
      <WorkOrderDNDItem />
    </>
  );
};

export default WorkOrderDNDList;
